import { useQuery } from '@tanstack/react-query';
import { useApi, useAuth } from '../../hooks';
import { useParams } from 'react-router-dom';
import { RawScoreDataPoint } from '../../models/score';

type Props = {
  limit?: number;
};

type ScoresResponse = {
  data: RawScoreDataPoint[];
};

export const useUserAybleScores = ({ limit = 1000 }: Props = {}) => {
  const { patient: userId } = useParams();

  const { api } = useApi();
  const { isAuthenticated, loading, userToken } = useAuth();

  const fetchUserAybleScores = async (): Promise<ScoresResponse> => {
    return await api({
      route: `/private/coach/users/${userId}/scores?limit=${limit}`,
      token: userToken,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Coach-Override': userId ?? '',
      },
    });
  };

  const {
    data: { data: aybleScores } = {},
    isLoading,
    isError,
  } = useQuery<ScoresResponse, Error>({
    queryKey: ['user-ayble-scores', userToken, userId, limit],
    queryFn: fetchUserAybleScores,
    enabled: !!userId && isAuthenticated && !loading && !!userToken,
    refetchOnWindowFocus: false,
  });

  return {
    aybleScores,
    isLoading,
    isError,
  };
};

export default useUserAybleScores;
